import { render } from "./SelectImage.vue?vue&type=template&id=0d86014e&scoped=true"
import script from "./SelectImage.vue?vue&type=script&lang=js"
export * from "./SelectImage.vue?vue&type=script&lang=js"

import "./SelectImage.vue?vue&type=style&index=0&id=0d86014e&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d86014e"]])

export default __exports__